//import axios from "axios";

async function TerraLCDSupplyCirculating() {
    /*
    const res = await axios.get("https://explorer.near.org/api/circulating-supply");
    
    const result = (res.circulating_supply_in_yoctonear) /  100000000000000000000
    console.log (result)
    return result
    */
   return '844,123,352';
}

export default TerraLCDSupplyCirculating
